import { render, staticRenderFns } from "./AddCountryModal.vue?vue&type=template&id=0cf5576e&scoped=true&"
import script from "./AddCountryModal.vue?vue&type=script&lang=js&"
export * from "./AddCountryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCountryModal.vue?vue&type=style&index=0&id=0cf5576e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5576e",
  null
  
)

export default component.exports